module.exports = __webpack_public_path__ + "img/16-mob.b5077884.svg";